<template>
  <div class="section">
    <div class="box">
      <div class="field">
        <label class="label">Search Name / Email</label>
        <div class="control">
          <input type="text" class="input" v-model="search" @keyup="searchMember()">
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Present</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member_row, index) in member_list" :key="index">
            <td v-text="member_row.name"></td>
            <td v-text="member_row.email"></td>
            <td><button class="button is-link" @click="addMember(member_row, index)">Present</button></td>
          </tr>
        </tbody>
      </table>
      <h4 class="title is-4">Present Member</h4>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Time</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(present_member_row, index) in present_member_list" :key="index">
            <td v-text="present_member_row.name"></td>
            <td v-text="present_member_row.email"></td>
            <td>
              <input type="time" class="input" v-model="present_member_list[index].time" @change="updatePresentTime(present_member_list[index], index)">
            </td>
            <td>
              <button class="button is-danger" @click="removeMember(present_member_row, index)">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      member_list: [],
      present_member_list: []
    }
  },
  created () {
    // Check Team Task sudah di buat atau belum
    this.checkTeamTask()
    // Load Member yang sudah masuk absent
    this.getAttendanceMember()
  },
  methods: {
    // Check Team Task created or not
    checkTeamTask () {
      var self = this
      self.flyGetSession('task/check_current_task').then(function (response) {
        if (response.data.response_code === 1) {
        } else {
          self.$router.push('/panel/task')
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // Added Member
    getAttendanceMember () {
      var self = this
      self.flyGetSession('task/get_present_member').then(function (response) {
        if (response.data.response_code === 1) {
          self.present_member_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    // Search Member
    searchMember () {
      var self = this
      if (self.search === '') {
        self.member_list = []
      }
      self.flyPostSession('task/search_member', {
        search: this.search,
        member_list: this.present_member_list
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.member_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    // Add present Member
    addMember (memberRow, index) {
      var self = this
      self.flyPostSession('task/present_member', {
        member_id: memberRow.id
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.member_list.splice(index, 1)
          self.getAttendanceMember()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    // Remove present Member
    removeMember (memberRow, index) {
      var self = this
      self.flyPostSession('task/remove_present_member', {
        attendance_id: memberRow.attendance_id
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.present_member_list.splice(index, 1)
          self.searchMember()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    // Update Present Time
    updatePresentTime (memberRow) {
      var self = this
      self.flyPostSession('task/update_present_member', {
        attendance_id: memberRow.attendance_id,
        time: memberRow.time
      }).then(function (response) {
        if (response.data.response_code === 1) {
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/Attendance.vue